<template>
  <div id="listItem" @click="toShow(imgUrl)" :style="`background:${color}`">
    <div class="item-box">
      <div class="left">
        <div class="left-icon-box">
          <img class="left-icon" :src="leftIcon" alt="">
        </div>
        <div class="left-text">{{title}}</div>
      </div>
      <div class="right">
        <img class="right-icon" src="images/ETC/rightArrows.png" alt="">
      </div>
      <div class="logo">
        <img :src="rightIcon" alt="">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "listItem",
    props:[
      'color',
      'leftIcon',
      'title',
      'rightIcon',
      'imgUrl',
    ],
    methods:{
      toShow(imgUrl) {
        this.$router.push(`/ETC/show?url=${imgUrl}`)
      }
    }
  }
</script>

<style scoped>
  #listItem{
    width: 92vw;
    height: 24.533vw;
    border-radius: 1.6vw;
    margin: 2.667vw auto;
    position: relative;
    overflow: hidden;
  }
  .item-box{
    height: 100%;
    padding: 0 4vw;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
  }
  .left{
    display: flex;
    align-items: center;
  }
  .left-icon-box{
    width: 16.533vw;
    height: 16.533vw;
    border-radius: 50%;
    background: white;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .left-icon{
    width: 10.667vw;
    height: 10.667vw;
  }
  .left-text{
    font-size: 4.533vw;
    color: #ffffff;
    margin-left: 2.933vw;
  }
  .right-icon{
    width: 1.867vw;
    height: 3.6vw;
    position: relative;
    z-index: 1;
  }
  .logo{
    width: 26.667vw;
    height: 26.667vw;
    position: absolute;
    right: 0;
    bottom: 4vw;
  }
  .logo>img{width: 100%;}
</style>
